export default __webpack_public_path__ + "static/media/accountingAutomation-black.65840305.svg";